import {Component, Input, OnChanges} from '@angular/core';
import {QuickActionButtonComponent} from "../quick-action-button/quick-action-button.component";
import {NgForOf} from "@angular/common";
import {QuickActions} from "../../../../messages-center/models/enums/quick-actions.enum";
import {UserQuickActionButton} from "../../../../messages-center/models/user-quick-action-button.model";
import {
  QUICK_ACTION_BUTTON_CONFIGURATION
} from "../../../../messages-center/models/consts/quick-action-button.-configuration.const";
import {CreatePaymentService} from "../../../services/create-payment.service";
import {Router} from "@angular/router";
import {SearchBoxService} from "../../../../core/navigation-search/services/search-box.service";
import {
  NavigationSearchConfigService
} from "../../../../core/navigation-search/services/navigation-search-config.service";
import {NavigationService} from "../../../../core/navigation/services/navigation.service";
import {QuickActionManagerService} from "../../../services/quick-action-manager.service";
import {FeatureName} from "../../../../core/feature-flags/models/feature-name.enum";
import {FeatureFlagsService} from "../../../../core/feature-flags/services/feature-flags.service";
import {MessagesService} from "../../../../message/services/messages.service";

@Component({
  selector: 'app-quick-action-manager',
  standalone: true,
  imports: [
    QuickActionButtonComponent,
    NgForOf
  ],
  templateUrl: './quick-action-manager.component.html',
  styleUrl: './quick-action-manager.component.scss'
})
export class QuickActionManagerComponent implements OnChanges {

  @Input() userActionsList:Array<QuickActions>;
  @Input() isLoading:boolean;
  @Input() isCreateMessageTypesEmpty:boolean;

  quickActionsButtons: Array<UserQuickActionButton>;
  isFxEnabled= false;
  constructor(private createPaymentService: CreatePaymentService,
              private searchBoxService: SearchBoxService,
              private navigationSearchConfigService: NavigationSearchConfigService,
              private router: Router,
              private navigationService: NavigationService,
              protected quickActionManagerService: QuickActionManagerService,
              protected featureFlagsService:FeatureFlagsService,
              protected messagesService: MessagesService) {
   this.isFxEnabled= !this.featureFlagsService.isFeatureOff(FeatureName.fxFeature);
  }

   ngOnChanges(): void {
    this.quickActionsButtons =  this.generateQuickActionButtons();
  }

   generateQuickActionButtons(): Array<UserQuickActionButton>{
    let arr = new Array<UserQuickActionButton>();
    this.userActionsList?.forEach(action=>arr.push(QUICK_ACTION_BUTTON_CONFIGURATION.get(action)))
    return arr
  }

  isButtonDisabled(id: string){
      if(id === 'landing-page-create-payment'){
        return this.isCreateMessageTypesEmpty;
      }
      return false;
  }

  onButtonClicked(event: QuickActions){
    switch (event){
      case QuickActions.SEARCH_PAYMENT:
        const messagesSearchBoxItem = this.navigationSearchConfigService.getSearchBoxItem('messages');
        this.searchBoxService.emitSearchBoxItem(messagesSearchBoxItem);
        break;
      case QuickActions.RECENT_SEARCH:
        this.router.navigate(['/home/messages-center/recent-searches']);
        break;
      case QuickActions.CREATE_PAYMENT://for single office also show modal with caller button
        this.openCreatePaymentModalAndSelectAction(QuickActions.CREATE_PAYMENT);
        break;
      case QuickActions.CREATE_CUSTOMER_PAYMENT:
      case QuickActions.CREATE_CUSTOMER_PAYMENT_TEMPLATE:
      case QuickActions.CREATE_REQUEST_FOR_PAYMENT:
      case QuickActions.CREATE_REQUEST_FOR_PAYMENT_TEMPLATE:
      case QuickActions.CREATE_FX_PAYMENT:
      default:
        this.onCreatePaymentActionButton(event);
    }
  }


  onCreatePaymentActionButton(action: QuickActions){
    let offices = this.navigationService.getWriteOnlyOffices();
    let localOfficeList=offices.filter(office=>office.name !=='***')
    let isSingleOffice = localOfficeList.length === 1;
    if(isSingleOffice){
     this.openSingleOfficePayment(action,offices[0])
      return;
    }
    this.openCreatePaymentModalAndSelectAction(action);
    if(action===QuickActions.CREATE_FX_PAYMENT){
      this.quickActionManagerService.fxWiredToggleChange$.next(true)
    }
  }

  openCreatePaymentModalAndSelectAction(action: QuickActions){
    this.createPaymentService.openModal().afterClosed().subscribe(data => {
      this.quickActionManagerService.fxWiredToggleChange$.next(false);
    });
    this.quickActionManagerService.updateCreatePaymentSelectedType(action);
  }

  protected openSingleOfficePayment(action:QuickActions,office){
    let officeName = office.name;
    let department =this.navigationService.getOfficeDepartments(officeName)[0]
    let paymentType = this.quickActionManagerService.getPaymentTypeByQuickAction(action,true);
    let fxEnhancementCheckbox = action === QuickActions.CREATE_FX_PAYMENT;
    this.messagesService.createMessage(officeName, department, paymentType.event,
      false, fxEnhancementCheckbox, this.isFxEnabled);
  }

}
